<template>
    <div class="home-container">
        <div class="row-container">
            <div class="square border-blue">
                <div class="item-title">会员总数</div>
                <div class="content color-blue">{{ homeData.memberTotalCount }}人</div>
            </div>
            <div class="square border-green">
                <div class="item-title">本月新增会员</div>
                <div class="item-date">{{ getMonth() }}</div>
                <div class="content color-green">{{ homeData.memberMonthCount }}人</div>
            </div>
            <div class="square border-yellow">
                <div class="item-title">今日新增会员</div>
                <div class="item-date">{{ getToday() }}</div>
                <div class="content color-yellow">{{ homeData.memberTodayCount }}人</div>
            </div>
        </div>
        <div class="row-container">
            <div class="square border-purple">
                <div class="item-title">本月充值金额</div>
                <div class="item-date">{{ getMonth() }}</div>
                <div class="content color-purple">￥{{ Number(homeData.rechargeMonth).toFixed(2) }}</div>
            </div>
            <div class="square border-cyan">
                <div class="item-title">本月扣款金额</div>
                <div class="item-date">{{ getMonth() }}</div>
                <div class="content color-cyan">￥{{ Number(homeData.chargeMonth).toFixed(2) }}</div>
            </div>
            <div class="square" style="background: transparent"></div>
        </div>
    </div>
</template>

<script>


import {queryHomeStats} from "@/api/business"

export default {
    name: 'home',
    data() {
        return {
            homeData: {
                memberTotalCount: 0,
                memberTodayCount: 0,
                memberMonthCount: 0,
                rechargeMonth: 0.00,
                chargeMonth: 0.00,
            },
        }
    },
    mounted() {
        this.initInfo()
    },
    methods: {
        initInfo() {
            queryHomeStats().then((res) => {
                this.homeData = res.data
            })
        },
        getToday() {
            const today = new Date()
            const year = today.getFullYear()
            const month = String(today.getMonth() + 1).padStart(2, '0')
            const day = String(today.getDate()).padStart(2, '0')
            return `${year}年${month}月${day}日`
        },
        getMonth() {
            const today = new Date()
            const year = today.getFullYear()
            const month = String(today.getMonth() + 1).padStart(2, '0')
            return `${year}年${month}月`
        },
    },
}
</script>

<style scoped>
.home-container {
    padding: 10px;
    height: 100%;
    overflow: auto;
}

.square {
    width: 32%; /* 留出1%的间隙 */
    padding-top: 17%; /* 与宽度相同，创建正方形 */
    position: relative;
    background-color: #ffffff;
}

.border-blue {
    border-top: 40px solid #2d8cf0;
    border-left: 1px solid #2d8cf0;
    border-bottom: 1px solid #2d8cf0;
    border-right: 1px solid #2d8cf0;
}

.color-blue {
    color: #2d8cf0;
}

.border-yellow {
    border-top: 40px solid #efba6b;
    border-left: 1px solid #efba6b;
    border-bottom: 1px solid #efba6b;
    border-right: 1px solid #efba6b;
}

.color-yellow {
    color: #efba6b;
}

.border-green {
    border-top: 40px solid #3fbb0f;
    border-left: 1px solid #3fbb0f;
    border-bottom: 1px solid #3fbb0f;
    border-right: 1px solid #3fbb0f;
}

.color-green {
    color: #3fbb0f;
}

.border-purple {
    border-top: 40px solid #9325dc;
    border-left: 1px solid #9325dc;
    border-bottom: 1px solid #9325dc;
    border-right: 1px solid #9325dc;
}

.color-purple {
    color: #9325dc;
}


.border-cyan {
    border-top: 40px solid #25ceb5;
    border-left: 1px solid #25ceb5;
    border-bottom: 1px solid #25ceb5;
    border-right: 1px solid #25ceb5;
}

.color-cyan {
    color: #25ceb5;
}

.row-container {
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;
}

.content {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    font-size: 50px;
    align-items: center;
    justify-content: center;
}

.item-title {
    position: absolute;
    top: -32px;
    left: 8px;
    right: 0;
    bottom: 0;
    color: #ffffff;
    font-size: 16px;
}

.item-date {
    position: absolute;
    top: -32px;
    right: 10px;
    bottom: 0;
    color: #ffffff;
    font-size: 16px;
}
</style>
